import { render, staticRenderFns } from "./TransactionProductSection.vue?vue&type=template&id=4fa2557a&scoped=true"
import script from "./TransactionProductSection.vue?vue&type=script&lang=js"
export * from "./TransactionProductSection.vue?vue&type=script&lang=js"
import style0 from "./TransactionProductSection.vue?vue&type=style&index=0&id=4fa2557a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa2557a",
  null
  
)

export default component.exports